import { ASPHALT_TON_CONVERSION_FACTOR } from "constants/Material";
import { ProductType, ProposalProduct } from "generated/graphql";
import useGetOrganization from "hooks/organization/useGetOrganization";
import { snakeCase } from "lodash";

export const useTonConversionFactor = (
  product: ProposalProduct,
  applicationRate: number | null
): number => {
  const { data: organization } = useGetOrganization();

  if (
    product.material.type === snakeCase(ProductType.ASPHALT) ||
    product.material.type === snakeCase(ProductType.ASPHALT_CURBING)
  ) {
    let asphaltTonConversionFactor = ASPHALT_TON_CONVERSION_FACTOR;
    if (organization?.conversionFactorOverride?.asphaltTonConversionFactorOverride) {
      asphaltTonConversionFactor = JSON.parse(
        organization.conversionFactorOverride.asphaltTonConversionFactorOverride
      );
    }

    return (
      product.material.tonConversionFactorOverride ??
      asphaltTonConversionFactor[applicationRate?.toString()] ??
      0.0
    );
  }

  if (product.material.type === snakeCase(ProductType.EXCAVATE_OUT)) {
    let excavateOutTonConversionFactor = ASPHALT_TON_CONVERSION_FACTOR;
    if (organization?.conversionFactorOverride?.excavateOutTonConversionFactorOverride) {
      excavateOutTonConversionFactor = JSON.parse(
        organization.conversionFactorOverride.excavateOutTonConversionFactorOverride
      );
    }
    return (
      product.material.tonConversionFactorOverride ??
      excavateOutTonConversionFactor[applicationRate?.toString()] ??
      0.0
    );
  }

  return 0;
};
